import { useCallback } from 'react';

import { useDialogs } from '@toolpad/core/useDialogs';

import SafeguardConfirmation from './SafeguardConfirmation';
import { SafeguardConfirmationDialogPayload } from './types';

function useSafeguardConfirmationDialog(DialogComponent = SafeguardConfirmation) {
  const dialog = useDialogs();

  return useCallback(
    (payload: SafeguardConfirmationDialogPayload) => dialog.open(DialogComponent, payload),
    [dialog, DialogComponent],
  );
}

export { SafeguardConfirmation };
export default useSafeguardConfirmationDialog;
